// extracted by mini-css-extract-plugin
export var avatarContainer = "_3y-1";
export var largeAvatarContainer = "_3y-2";
export var smallAvatarContainer = "_3y-0";